import { useState } from 'react';

import { Dropcontainer } from '@mobiscroll/react';

import { isDispatchTrip } from '../../common/isDispatchTrip';
import { useTripMenuActions } from '../../DispatchCalendar/useTripMenuActions';

type UnassignTripsDropTargetProps = {
  children: React.ReactNode;
};

export function UnassignTripsDropTarget({
  children,
}: UnassignTripsDropTargetProps) {
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [dropcontainerEl, setDropcontainerEl] = useState<HTMLDivElement | null>(
    null
  );
  const menuActions = useTripMenuActions();
  return (
    <div
      ref={(ref) => setDropcontainerEl(ref)}
      className={`flex h-full w-full flex-col transition-colors
        ${isDraggingOver ? 'bg-gray-100' : ''}
        `}
    >
      <Dropcontainer
        element={dropcontainerEl}
        onItemDragEnter={() => {
          setIsDraggingOver(true);
        }}
        onItemDragLeave={() => {
          setIsDraggingOver(false);
        }}
        onItemDrop={(dropEvent) => {
          setIsDraggingOver(false);
          const data = dropEvent.data;
          if ('trip' in data && isDispatchTrip(data.trip)) {
            menuActions.unassign(data.trip.id, null);
          } else {
            console.error('Dropped data is not a trip:', data);
            throw new Error('No trip id found in drop event');
          }
        }}
      >
        {children}
      </Dropcontainer>
    </div>
  );
}
